export enum SearchScopeEnum {
    GLOBAL = 'global',
    LOCAL = 'local',
}
